import React, { useState, useEffect} from "react";
import { Button,Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import cssStyles from "./roomplanonboarding.module.scss";
import Box from '@mui/material/Box';
import { useDispatch } from 'react-redux';
import { useRouter } from "next/router";
import Modal from '@mui/material/Modal';
import { gtmPageOnloadTracking, gtmClickTracking } from "@/utils";



// Define the interface for room label items
interface RoomLabelItem {
    customerId: string;
    roomType: string;
    roomLabel: string;
    roomId: string;
  }

interface RoomPlanSelectorProps {
  // setActiveComponent: (component: string) => void;
  designImage?: any;
  onCloseOverlay?: Function;
  handleOverlayBack?: Function;
  builderImg?: any;
  createdAt?: any
}

const ProjectCreationSuccessModal: React.FC<RoomPlanSelectorProps> = ({
  // setActiveComponent, 
  designImage = {}, 
  onCloseOverlay = () => {}, 
  handleOverlayBack = () => {} ,
  builderImg = {},
  createdAt = {}
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [roomType, setRoomType] = useState<string>('');
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    handleResize();
    if (createdAt) {
      const formatted = dateConversion(createdAt);
      setFormattedDate(formatted);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect( ()=> {
    if(router.query && router.query.roomType) {
        setRoomType(router.query.roomType as string);
    }
  }, [router.query.roomType]);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767); // Detect mobile screen
    setIsTablet(window.innerWidth > 767 && window.innerWidth <= 1024); // Tablet from 768px to 1024px
  };
  const dateConversion = (dateString: any) => {
    const date = new Date(dateString);

    // Extract parts of the date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear() % 100; // Get last two digits of the year

    // Format the date as DD/MM/YY
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  };

return (
    <>
        <main className="home-container">

            {/* Mweb Form */}
            {isModalOpen && (
            <Modal 
              open={isModalOpen} 
              onClose={() => setIsModalOpen(false)} 
              disablePortal
              disableEnforceFocus
              disableAutoFocus
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)'
              }}
              >
            <>
            {(isMobile || isTablet) &&
                <div className={cssStyles.container}>

                <Box component="div" className={cssStyles.mainContainer}>
                <div className={cssStyles.CloseIconMWeb} >
                  {/* <ArrowBackIosIcon sx={{ fontSize: 30, color:'#a5a4a9' }} onClick = {() => handleOverlayBack?.()} /> */}
                  <img className={cssStyles.logo_img} src="/assets/img/Nestingale_logo.png" alt="Nestingale_Logo_img"></img>
                  <CloseIcon sx={{ fontSize: 20, color:'#595959', justifyContent:'right'}} onClick={() => { setIsModalOpen(false); onCloseOverlay?.();} }/>
                </div>
                    
                    {/* Header Section */}
                  <Box component='div' className={cssStyles.formContainer}>
                    <Box component="div"  className={cssStyles.header1} >
                        <Typography component="h2" variant="h2" className={cssStyles.headerText6} >A project has been created with your</Typography>
                        <Typography component="h2" variant="h2" className={cssStyles.headerText6} >selected design</Typography>
                    </Box>

                    {/* Buttons */}
                    <Box  component='div' className={cssStyles.optionsContainer}>
                        <Box component = 'div' sx= {{    height: '100%', width: '88%', display: 'flex', flexDirection:'column'}}>
                          <img src={designImage} style={{width:'100%', height: "100%", borderRadius: "20px 20px 20px 20px"}}></img>
                          {/* <img src={builderImg} style={{width:'100%', height: "50%", borderRadius: "0px 0px 20px 20px"}}></img> */}
                        </Box>

                        <Box component='div' sx={{    display: 'flex',
                                      flexDirection: 'column',
                                      marginTop: '5%',
                                      justifyContent: 'left',
                                      width: '95%'}}>
                            <Typography component='p' className={cssStyles.optionsContainerOptionText} sx = {{color:'#303030'}} >{`Project - ${formattedDate}`}</Typography>
                            <Typography component='p' className={cssStyles.optionsContainerOptionText} sx = {{color:'#b8c0c0'}} >{`Created ${formattedDate}`}</Typography>
                        </Box>

                        <Box component='div' className={cssStyles.optionsContainerText}  sx= {{ border: 'none'}}>
                            <Typography component='p' className={cssStyles.optionsContainerOptionText} sx = {{color:'black'}} >To continue designing it, visit</Typography>
                            <Typography component='p' className={cssStyles.optionsContainerOptionText} sx = {{color:'black'}} >My Projects on your desktop.</Typography>

                        </Box>
                        <Button component='div' variant="contained" 
                            className={cssStyles.mainButton}
                            onClick={() => {
                              gtmClickTracking({
                                event: 'selects OK',
                                pageType: 'selects OK',
                              })
                               setIsModalOpen(false); onCloseOverlay?.();} }
                            sx={{
                                '&:disabled': {
                                    backgroundColor: '#fea27d !important', // Force background color with !important
                                    color: 'white !important',    
                                },
                            }}
                        >
                        OK
                    </Button>
                    </Box>
                  </Box>
                </Box>
                </div>

            }
            </>
             </Modal>)}   
        </main>
     
      
    </>
  );
};

export default ProjectCreationSuccessModal;